<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Partnenaires</h1>
    </div>

    <Nav />

    <!-- Affichage d'erreur -->
    <div class="form-group">
      <div
        class="alert text-left formatted-text"
        :class="{
          'alert-danger': error,
        }"
        role="alert"
        v-show="error"
      >
        {{ this.error }}
      </div>
    </div>

    <div
      class="table-responsive"
      v-if="userPermissions.some((e) => [P_READ_PARTNER].includes(e))"
    >
      <table
        v-if="partners.length != 0"
        id="dataTable"
        class="table table-bordered table-striped table-hover"
      >
        <thead>
          <tr>
            <th>Désignation</th>
            <th>Description</th>
            <th>Lien</th>
            <th>Type</th>
            <th>Photo</th>
            <th>Ajouté le</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <PartnerItem
            v-for="(partner, index) in partners"
            :partner="partner"
            :key="partner.id + index"
          />
        </tbody>
      </table>
      <div v-else>
        <p style="text-align: center">
          <br />
          Aucunes données
        </p>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
import { mapGetters } from "vuex";

import * as $ from "jquery"; // for datatable

import Nav from "./Nav";
import PartnerItem from "./PartnerItem";
import { FETCH_PARTNERS } from "../../store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";

import frLocalDatatable from "@/assets/french.json";
import { P_READ_PARTNER } from "@/helpers/permissions";

export default {
  name: "PartnerList",
  components: {
    Nav,
    PartnerItem,
  },
  data() {
    return {
      error: "",
      P_READ_PARTNER,
    };
  },
  async mounted() {
    await this.getPartners();
  },
  computed: {
    ...mapGetters(["partners", "userPermissions"]),
  },
  methods: {
    getPartners() {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(FETCH_PARTNERS)
        .catch((error) => {
          this.error = `${error}`;
          if (error.errors) {
            this.error += ` \n ${JSON.stringify(error.errors)} `;
          }
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
          // datatable
          $(document).ready(function () {
            $("#dataTable").DataTable({
              language: frLocalDatatable,
            });
          });
        });
    },
  },
};
</script>

<style lang="scss">
</style>